import { FormArray, FormControl, FormGroup, ValidationErrors } from '@angular/forms';

import { TranslateService } from "@ngx-translate/core";
//import { isString } from 'ngx-bootstrap/chronos/utils/type-checks';

export class CustomValidators {
    constructor(public translate: TranslateService) { }
    static validEmail(c: FormControl): ValidationErrors {
        const email = c.value;
        const reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        var isValid = true;
        const message = {
            'validEmail': {
                'message': 'Should be valid email.'
            }
        };
        if (reg.test(email)) {
            isValid = true;
        }
        else {
            isValid = false;
        }
        return isValid ? null : message;
    }


    static isNum(c: FormControl): ValidationErrors {
        const num = Number(c.value);
        const isValid = !isNaN(num);
        const message = {
            'isNum': {
                'message': 'This field must be a valid number' // Will changes the error defined in errors helper.
            }
        };
        return isValid ? null : message;
    }
    static isStringFunc(s:any) {
        return (typeof s === 'string' || s instanceof String) ? true : false
        }

    static isString(c: FormControl): ValidationErrors {
        const string = String(c.value);
        const isValid = !this.isStringFunc(string);
        const message = {
            'isString': {
                'message': 'This field must contain Valid text' // Will changes the error defined in errors helper.
            }
        };
        return isValid ? null : message;
    }
    static isNegative(c: FormControl): ValidationErrors {
        const num = Number(c.value);
        const isValid = num > 0
        const message = {
            'isNegative': {
                'message': 'Please enter non negative values' // Will changes the error defined in errors helper.
            }
        };
        return isValid ? null : message;
    }

    // static isReadOnlyByRole(c: FormControl): ValidationErrors {

    // }
}